import axios from "axios";
import { severityCode } from "@/services/api/httpClient";

// api ingang
let apiClient;

export default {
  install(Vue, options) {
    //console.log("httpClientUnauthorized created", options);
    apiClient = axios.create({
      baseURL: `${options.portalUrl}api/`,
      timeout: 20000,
      // timeout: 5000,
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
        // anything you want to add to the headers
      },
    });
  },
};

const getRequest = async (url, params) => {
  let message = undefined;
  let code = undefined;
  let severity = severityCode.none;
  let response = await apiClient.get(url, { params: params }).catch((error) => {
    message = error.toString();
    severity = severityCode.error;
    code = error.response?.status;
  });
  if (message == undefined) {
    switch (response.status) {
      case 204: // no-content
        message = "Er zijn geen gegevens";
        severity = severityCode.warning;
        code = response.status;
        break;
      case 290: // too many results
        message = "Teveel resultaten";
        severity = severityCode.warning;
        code = response.status;
        break;
    }
  }
  return { data: response ? response.data : undefined, message: message, severity: severity, code: code };
};


export { apiClient, getRequest, severityCode };
